import { ContentType } from 'src/app/content-management/shared/enums/content-type';
import { Surtitle } from './i-surtitle';

export interface IChapter {
  contentId: string;
  surtitle: string;
  surtitlesDetailed: Surtitle[];
  linkTitle: string;
  order?: number;
  contentType?: ContentType;
}

export class Chapter implements IChapter {
  constructor(
    public contentId: string,
    public surtitle: string,
    public surtitlesDetailed: Surtitle[],
    public linkTitle: string,
    public contentType?: ContentType,
    public order?: number
  ) {}
}
